import { IProductData } from 'interfaces/IProductData';
import React from 'react';
import MultipleInstallments from './MultipleInstallments';
import WithoutInstallment from './WithoutInstallment';
import Coupon from './../Coupon/index';
import Translate from 'components/Translate';
import CouponPrice from '../Coupon/CouponPrice/index';
import Grid from '@material-ui/core/Grid/Grid';
import { paymentService } from 'services/PaymentService';
import { Subscription } from './Subscription';
import { enPaymentType } from 'enums/enPaymentType';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { getCdnImage } from '../../../functions';

const styles = require('./price.css');

export enum enLayout {
  column = 'column',
  row = 'row'
}

interface IPriceProps {
  cart: IProductData;
  circle?: boolean;
  showConfigSelectors?: boolean;
  showBorder?: boolean;
  layout?: enLayout;
  hideMultipleInstallments?: boolean;
  isTicket?: boolean;
}

interface IState extends IStateBase {
  justTitle: boolean;
}

export default class Price extends BaseComponent<IState, IPriceProps> {

  constructor(props: IPriceProps) {
    super(props);

    this.state = {
      justTitle: false,
    };
  }

  componentDidMount() {
    paymentService.getPaymentResult()
      .take(1)
      .subscribe(t => {
        this.setState({ justTitle: true });
      });
  }

  render() {

    const { installments } = this.props.cart;
    const props = this.props;
    const showBorderClass = this.props.showBorder ? 'show-border' : '';

    const { justTitle } = this.state;

    if (!this.state || !installments) {
      return null;
    }

    const isFree = props.cart.paymentType === enPaymentType.FREE;
    const isSubscription = props.cart.paymentType === enPaymentType.SUBSCRIPTION;

    return (
      <div className={`chk-payment-option ${styles.component} ${showBorderClass}`}>

        <Grid item xs={12}>
          {justTitle
            ? <Grid item xs={12}>
              <h4 className='chk-header-title'>{props.cart.title}</h4>
            </Grid>
            : <Grid item xs={12} sm={12} className='chk-product-infos' >
              {!props.isTicket && <img src={getCdnImage(props.cart.config.logo)} id='logo-content' />}
              <Grid item xs={12}>
                {!props.isTicket && <h4 className='chk-header-title theme-label'>{props.cart.title}</h4>}
                <CouponPrice />
                {[enPaymentType.NORMAL, enPaymentType.ECOMMERCE].includes(props.cart.paymentType)
                  ? installments.length > 1 && !props.hideMultipleInstallments
                    ? <MultipleInstallments cart={props.cart} isTicket={props.isTicket} />
                    : <WithoutInstallment cart={props.cart} />
                  : null
                }

                {isFree && <Translate term={'Gratuito'} />}

                {isSubscription && <Subscription subscription={props.cart.subscription} />}

                <Grid item xs={6}>
                  <Coupon />
                </Grid>
              </Grid>
            </Grid>
          }
        </Grid>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Cart/Price/index.tsx